import { hash } from '@ember/helper';

import Component from 'umg-ember-backend/components/record-detail/forms';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsUrlAliasComponent extends Component {
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field @property='name' />

            <fieldset.field
              @property='cmsState'
              @type='select-value'
              @options={{this.cmsStateOptions}}
            />
          </form.fieldset>
        </div>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='assignments' as |fieldset|>
            <fieldset.field
              @property='parent'
              @type='belongs-to'
              @on={{hash openNewRecord=false openRecord=false}}
            />

            <fieldset.field
              @property='artist'
              @type='belongs-to'
              @on={{hash
                openNewRecord=false
                openRecord=false
                removeRecord=false
              }}
              @disabled={{true}}
            />

            <fieldset.field
              @property='webSeries'
              @type='belongs-to'
              @on={{hash
                openNewRecord=false
                openRecord=false
                removeRecord=false
              }}
              @disabled={{true}}
            />
          </form.fieldset>
        </div>
      </div>
    </Form>
  </template>
}
